import React from "react";
import classNames from "classnames";

import ReactModal from "react-modal";

import "./Modal.scss";

import ModalProps from "./Modal.types";

import ModalFooter from "./components/ModalFooter";
import ModalHeader from "./components/ModalHeader";

const Modal = ({
  show,
  title,
  size = "full",
  subtitle,
  children,
  onClose,
  onSave,
  onAction,
  closeLabel,
  saveLabel,
  actionLabel,
  customHeader,
  customFooter,
}: ModalProps) => {
  const modalClass = classNames("elemental-modal", `modal-${size}`);

  const modalContentClass = classNames(
    "elemental-modal-content",
    `modal-${size}`
  );

  return (
    <div data-testid="elemental-modal">
      <ReactModal
        ariaHideApp={false}
        isOpen={show}
        className={modalClass}
        overlayClassName="elemental-modal-overlay"
        contentLabel="Modal content"
        // Per EDS, we should not close the modal when clicking on the overlay
        //onRequestClose={onClose}
      >
        {customHeader ? (
          <div data-testid="elemental-modal-custom-header">{customHeader}</div>
        ) : (
          <ModalHeader
            size={size}
            title={title}
            subtitle={subtitle}
            onClose={onClose!}
          />
        )}

        <div className={modalContentClass}> {children} </div>

        {customFooter ? (
          <div data-testid="elemental-modal-custom-footer">{customFooter}</div>
        ) : (
          <ModalFooter
            size={size}
            onClose={onClose}
            onSave={onSave}
            onAction={onAction}
            closeLabel={closeLabel}
            saveLabel={saveLabel}
            actionLabel={actionLabel}
          />
        )}
      </ReactModal>
    </div>
  );
};

export default Modal;
